import DanmuJs from './danmu'
import './style/index.scss'
export default DanmuJs
